import {
  DASHBOARD_CONFIG_APP_DATA,
  WORKFLOW_APP_OBJECT_DATA,
  DASHBOARD_CONFIG_ORG_DATA,
  ACTION_JOB_RES_DATA,
  ERROR_SHOW,
  NOTIFICATIONS_ARRAY,
  DASHBOARD_APPS_LIST_DATA,
  DASHBOARD_PUBLIC_APPS_LIST_DATA,
  DASHBOARD_EXTERNAL_APPS_LIST_DATA
} from "./appviewaction";

export const initState = {
  notificationsArray: [],
  dashboardAppsList: [],
  dashboardExternalAppsList: [],
  dashboardAppConfig: {},
  dashboardOrgConfig: [],
  workflowobject: {},
  actionJobResData: {},
  errorShow: null
};

export const appviewreducer = (state = initState, { type, payload }) => {
  switch (type) {
    case WORKFLOW_APP_OBJECT_DATA:
      return {
        ...state,
        workflowobject: payload
      };

    case DASHBOARD_CONFIG_APP_DATA:
      return {
        ...state,
        dashboardAppConfig: payload
      };

    case DASHBOARD_CONFIG_ORG_DATA:
      return {
        ...state,
        dashboardOrgConfig: payload
      };

    case DASHBOARD_APPS_LIST_DATA:
      return {
        notificationsArray: [],
        dashboardAppsList: payload,
        dashboardExternalAppsList: state.dashboardExternalAppsList || [],
        dashboardAppConfig: {},
        dashboardOrgConfig: [],
        workflowobject: {},
        actionJobResData: {},
        errorShow: null
      };

    case DASHBOARD_PUBLIC_APPS_LIST_DATA:
      return {
        notificationsArray: [],
        dashboardPublicAppsList: payload,
        dashboardAppConfig: {},
        dashboardOrgConfig: [],
        workflowobject: {},
        actionJobResData: {},
        errorShow: null
      };

    case ACTION_JOB_RES_DATA:
      return {
        ...state,
        actionJobResData: payload
      };

    case ERROR_SHOW:
      return {
        ...state,
        errorShow: payload
      };

    case NOTIFICATIONS_ARRAY:
      return {
        ...state,
        notificationsArray: payload
      };

    case DASHBOARD_EXTERNAL_APPS_LIST_DATA:
      return {
        ...state,
        dashboardExternalAppsList: payload
      };

    default:
      return state;
  }
};
